export const api_credentials = {
  key: "fc737e7d-7e1c-4d83-8d0d-63aab450e286",
  user: "80edays-api-user",
  url: "https://api.tracking.80edays.com",
  socketURL : "https://ws.tracking.80edays.com/req-data"
};
